import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { FOUNDERS } from '../content';
export function Founders() {
  return <section id="founders" className="border-t border-border bg-card" aria-labelledby="founders-heading" data-id="element-24" data-mp="1b3s7v6624buo">
      <div className="section-shell py-16 lg:py-20" data-id="element-25" data-mp="162codijj2dee">
        <p className="overline" data-id="element-26" data-mp="115m9uzndfpv3">On the trail</p>
        <h2 id="founders-heading" className="mt-5 font-serif text-h3 lg:text-h2" data-id="element-27" data-mp="114uqqoaynklp">
          Founders we&rsquo;ve worked with
        </h2>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-28" data-mp="rfjhn1o2qfxt">
          {FOUNDERS.map(f => <li key={f.company} className="flex flex-col rounded-lg border border-border bg-background p-6" data-id="element-29" data-mp="nd6eml0pow4q">
              {/* Co-founders overlap slightly so the pair reads as one team. */}
              <div className="flex" data-id="element-30" data-mp="df8n9onk2j7w">
                {f.photos.map((p, i) => <span key={p.name} className={`block h-20 w-20 overflow-hidden rounded-full bg-secondary ring-4 ring-background ${i > 0 ? '-ml-4' : ''}`} data-id="element-31" data-mp="8gfbq1rtx2ad" data-mpi={i}>
                    <img src={p.src} alt={p.name} loading="lazy" className={`h-full w-full object-cover object-top ${p.zoom ? 'scale-125' : ''}`} data-id="element-32" data-mp="8376hgs89ieq" />
                  </span>)}
              </div>

              <h3 className="mt-5 font-serif text-h4 leading-snug" data-id="element-33" data-mp="lzc9itkzq6fw">
                {f.url ? <a href={f.url} target="_blank" rel="noopener noreferrer" className="group inline underline decoration-border-strong decoration-1 underline-offset-4 transition-colors hover:text-primary hover:decoration-current" data-id="element-34" data-mp="qyfgijkj6mqi">
                    {f.company}
                    <ArrowUpRight size={16} aria-hidden="true" className="ml-1 inline-block align-baseline opacity-60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100" data-id="element-35" data-mp="31tmaienorwc6" />
                    <span className="sr-only" data-id="element-36" data-mp="yiq1cidyt9xt"> (opens in a new tab)</span>
                  </a> : f.company}
              </h3>
              <p className="mt-2 text-body-sm font-semibold" data-id="element-37" data-mp="om3ghtln2ivs">{f.founders}</p>
              <p className="mt-1 flex items-center gap-1.5 text-caption text-muted-foreground" data-id="element-38" data-mp="kkhwloaot4c3">
                <MapPin size={12} aria-hidden="true" data-id="element-39" data-mp="fkwy1ezfixzw" />
                {f.location}
              </p>
              <p className="mt-4 text-body-sm leading-body text-muted-foreground" data-id="element-40" data-mp="ambyzivwykd1">{f.line}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}